import {
  Button,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Heading,
  HStack,
  Input,
  Stack,
  useToast,
  VStack,
} from '@chakra-ui/react';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Card from '../Card';
import {
  getUserDetails,
  updatePassword,
} from '../../stores/slices/user/userActions';

const Password = () => {
  const dispatch = useDispatch();
  const toast = useToast();

  const schema = yup
    .object({
      password: yup
        .string()
        .min(8, 'Must be at least 8 characters long')
        .required('Password is required'),
      confirmPassword: yup
        .string()
        .required('Please retype your password.')
        .oneOf([yup.ref('password')], 'Your passwords do not match.'),
    })
    .required();
  const {
    register,
    handleSubmit,
    reset,
    control,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSave = async data => {
    const res = await dispatch(updatePassword(data));
    if (res.type === 'user/updatePassword/rejected') {
      toast({
        title: 'Something went wrong',
        description: 'Please try again later.',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
      });
    } else {
      dispatch(getUserDetails());
      toast({
        description: 'Account details updated',
        colorScheme: 'primary',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
        variant: 'primary',
      });
    }
  };
  return (
    <Card mx={'auto'} h={'full'} px={{ base: 4, md: 10 }}>
      <form onSubmit={handleSubmit(onSave)}>
        <VStack alignItems={'start'} spacing={'8'}>
          <VStack w={'full'} alignItems={'start'}>
            <HStack
              alignItems={'center'}
              justifyContent={'space-between'}
              spacing={'10'}
              w={'full'}
            >
              <Heading as="h4" size="md">
                Change Password
              </Heading>

              <Button type="submit" isLoading={isSubmitting}>
                Save
              </Button>
            </HStack>
            <Stack w={'full'} direction={{ base: 'column', lg: 'row' }}>
              <FormControl id="password" isInvalid={errors.password}>
                <FormLabel htmlFor="password">Password</FormLabel>
                <Input
                  type="password"
                  id="password"
                  {...register('password')}
                />
                <FormErrorMessage>
                  {errors.password && errors.password.message}
                </FormErrorMessage>
                <FormHelperText>
                  Your password must be 8-20 characters long, contain letters
                  and numbers, and must not contain spaces, or emoji.
                </FormHelperText>
              </FormControl>
              <FormControl
                id="confirmPassword"
                isInvalid={errors.confirmPassword}
              >
                <FormLabel htmlFor="confirmPassword">
                  Confirm Password
                </FormLabel>
                <Input
                  type="password"
                  id="confirmPassword"
                  {...register('confirmPassword')}
                />
                <FormErrorMessage>
                  {errors.confirmPassword && errors.confirmPassword.message}
                </FormErrorMessage>
              </FormControl>
            </Stack>
          </VStack>
        </VStack>
      </form>
    </Card>
  );
};

export default Password;
